webpackJsonp([134230018186314],{

/***/ 969:
/***/ (function(module, exports) {

	module.exports = {"title":"Lagar sig að þér","headline":"Við erum öll einstök. Góður einkaþjálfari sér okkur í réttu ljósi og áttar sig á styrkleikum okkar og veikleikum ásamt því hvernig okkur hentar best að æfa og hvernig við erum upplögð þann daginn. Þetta nýtir hann til að laga þjálfunina þ.a. hún henti okkur sem best. Við vinnum að því að ná svipuðum árangri með hjálp nútíma tækni þar með talið gervigreindar. Markmið okkar er að gefa tölvunni mannlega eiginleika.","subtitle":"Þjálfaðu með forriti sem lagar sig að þér!","p1":"Okkar markmið er að gera þér kleyft að verða besta mögulega útgáfa af sjálfum þér.","p2":"Við gerum forritinu okkar kleyft að laga sig að þér og þínum þörfum.","p3":"Við nýtum nútíma tækni, bæði gervigreind og líka (valkvætt) lífkennamælingar á borð við","p3LinkText":"augn fylgni og greiningu svipbrigða","p3a":null,"p4":"Náðu þér í einkaþjálfara sem er til staðar þegar þér hentar 24/7 hvar sem þú ert og hefur það eitt markmið að veita þá þjálfun sem þér hentar best!"}

/***/ }),

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(9);
	
	var _Link = __webpack_require__(8);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _gatsbyImage = __webpack_require__(12);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _reactIntl = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  var content = props.content,
	      data = props.data;
	
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'wrapper' },
	      _react2.default.createElement(_gatsbyImage2.default, { sizes: data.img.childImageSharp.sizes })
	    ),
	    _react2.default.createElement(
	      _reactstrap.Container,
	      { className: 'py-4' },
	      _react2.default.createElement(
	        'div',
	        { className: 'my-3' },
	        _react2.default.createElement(
	          'h3',
	          { className: 'text-color-title' },
	          content.title
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          content.headline
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h4',
	          { className: 'text-color-subtitle' },
	          content.subtitle
	        ),
	        _react2.default.createElement(
	          'p1',
	          null,
	          content.p1
	        ),
	        _react2.default.createElement(
	          'p2',
	          null,
	          content.p2
	        ),
	        _react2.default.createElement(
	          'p3',
	          null,
	          content.p3,
	          _react2.default.createElement(
	            _Link2.default,
	            { to: '/methods/biometrics' },
	            ' ',
	            content.p3LinkText,
	            ' '
	          ),
	          content.p3a
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'text-center my-5' },
	        _react2.default.createElement(
	          _Link2.default,
	          { className: 'btn btn-lg btn-success', to: '/software/ocuchess' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'downloadOcuchess' }),
	          ' ',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'downloadOcuchessLine2' })
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 501:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _personalizedLayout = __webpack_require__(181);
	
	var _personalizedLayout2 = _interopRequireDefault(_personalizedLayout);
	
	var _personalized = __webpack_require__(969);
	
	var _personalized2 = _interopRequireDefault(_personalized);
	
	var _reactHelmet = __webpack_require__(5);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Sk\xE1kgreind | Lagar sig a\xF0 \xFE\xE9r'
	      )
	    ),
	    _react2.default.createElement(_personalizedLayout2.default, _extends({ content: _personalized2.default }, props))
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-methods-personalized-index-is-js-91d8b34e5321091787af.js